/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Lpdealoverviewcontent_Entervalue5Inputs */

const en_coinvestments_lpdealoverviewcontent_entervalue5 = /** @type {(inputs: Coinvestments_Lpdealoverviewcontent_Entervalue5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter value...`)
};

/**
* | output |
* | --- |
* | "Enter value..." |
*
* @param {Coinvestments_Lpdealoverviewcontent_Entervalue5Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_lpdealoverviewcontent_entervalue5 = /** @type {((inputs?: Coinvestments_Lpdealoverviewcontent_Entervalue5Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Lpdealoverviewcontent_Entervalue5Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_lpdealoverviewcontent_entervalue5(inputs)
});
export { coinvestments_lpdealoverviewcontent_entervalue5 as "coInvestments_lpDealOverviewContent_enterValue" }